module.exports = __webpack_public_path__ + "static/media/e-logo.ea2b72f8.jpg";